import React from "react";
import { Link } from "react-router-dom";
import AGMethod from "@/components/home/AGMethod";
import { Overline } from "@/components/brand/SectionDivider";
import { ConcentricMonogram } from "@/components/brand/ConcentricMonogram";
import { AmbientLight } from "@/components/brand/AmbientLight";
import useDocumentTitle from "@/lib/useDocumentTitle";

export default function Process() {
  useDocumentTitle("Our Approach | AG Public Adjusting");
  return (
    <main data-testid="process-page" className="pt-32 bg-midnight-gradient">
      <section className="relative py-24 lg:py-36 overflow-hidden">
        <AmbientLight size={1100} color="blue" intensity={0.5} style={{ top: "-10%", right: "20%" }} />
        <div className="hidden lg:block absolute left-12 top-1/2 -translate-y-1/2 opacity-30 pointer-events-none" aria-hidden>
          <ConcentricMonogram size={450} variant="ghost" glowColor="blue" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
          <Overline className="mb-8">Our Approach</Overline>
          <h1 className="font-display-tight text-white text-[clamp(2.8rem,6vw,6rem)] leading-[0.95] tracking-[-0.045em] max-w-4xl">
            The AG Method.
            <br />
            <span className="gold-metallic font-display font-light">A documented practice.</span>
          </h1>
          <p className="mt-12 text-ag-text-secondary text-lg md:text-xl leading-[1.65] font-light max-w-3xl">
            Every claim that enters the firm follows the same five-stage sequence. The method is the
            firm's institutional memory — and the reason the recovery does not depend on any single individual.
          </p>
        </div>
      </section>

      <AGMethod />

      <section className="py-24 lg:py-32 border-t border-white/5 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Overline className="mb-8">Apply the Method</Overline>
          <h2 className="font-display-tight text-white text-[clamp(2.5rem,5vw,4rem)] mb-10 leading-[0.98] tracking-[-0.04em]">
            Begin the <span className="gold-metallic font-display font-light">intake stage.</span>
          </h2>
          <Link to="/free-claim-evaluation" data-testid="process-cta-evaluation" className="btn-gold inline-flex items-center gap-3">
            Free Claim Evaluation →
          </Link>
        </div>
      </section>
    </main>
  );
}
